// extracted by mini-css-extract-plugin
module.exports = {"Tweet":"Tweet_Tweet__2v7eV","TweetContent":"Tweet_TweetContent__3YRFg","Retweet":"Tweet_Retweet__2JXTt","IconArrow":"Tweet_IconArrow__SW6EF"};